<template>
  <api-info-block title="API变动记录" v-model="visible">
    <div class="api-content__info">
      <Table :columns="columns1" width="900" :data="apiChangeHistory"></Table>
    </div>
  </api-info-block>
</template>

<script>
// eslint-disable-next-line
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import ApiInfoBlock from "./api-info-block.vue";

export default {
  data() {
    return {
      columns1: [
        {
          title: "变动日期",
          key: "updateTime"
        },
        { title: "变动参数", key: "paramName" },
        { title: "变动内容", key: "operation" },
        { title: "变动前", key: "olds" },
        { title: "变动后", key: "news" },
        { title: "说明", key: "paramRemark" }
      ],

      visible: false
    };
  },
  computed: {
    ...mapGetters({
      apiChangeHistory: "apiDoc/apiChangeHistory"
    })
  },

  components: {
    ApiInfoBlock
  }
};
</script>

<style lang="less" scoped>
.api-content__info {
  margin-top: 16px;
}
</style>
